import { Component, Input } from '@angular/core';
import { HarvestActivityReportStatus } from '../../local-db/objects/harvest-activity-report';

@Component({
  selector: 'app-report-status-tag',
  standalone: false,
  templateUrl: './report-status-tag.component.html',
  styleUrl: './report-status-tag.component.scss'
})
export class ReportStatusTagComponent{
    @Input() status: HarvestActivityReportStatus
  protected readonly HarvestActivityReportStatus = HarvestActivityReportStatus;
}
